import { Component } from '@angular/core';
import { WindowRef } from '@ca/core/services';

@Component({
    selector: 'ca-landingpage-placeholder',
    templateUrl: './landingpage-placeholder.component.html',
    styleUrls: ['./landingpage-placeholder.component.scss'],
})
export class LandingpagePlaceholderComponent {
    constructor(private windowref: WindowRef) {}
    get isLocalEnvironment(): boolean {
        return this.windowref.isLocalhost;
    }
}
